/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Translation } from '../../models/translation';
import { UpdateTranslationDto } from '../../models/update-translation-dto';

export interface TranslationsControllerUpdate$Params {

/**
 * The translation id
 */
  id: string;
  
    /**
     * The translation data to update the translation
     */
    body: UpdateTranslationDto
}

export function translationsControllerUpdate(http: HttpClient, rootUrl: string, params: TranslationsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Translation>> {
  const rb = new RequestBuilder(rootUrl, translationsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Translation>;
    })
  );
}

translationsControllerUpdate.PATH = '/translations/{id}';
